<template>
  <div :class="$style.wrapper">
    <h2 :class="$style.title">Сроки доставки</h2>
    <p :class="$style.subtitle">
      Укажите среднее время, за которое вы доставляете товар до пункта выдачи и
      аутентификации.
    </p>

    <button
      :class="$style.selectField"
      type="button"
      @click="
        $router.push({
          name: 'DeliveryPicker',
          query: {
            hours: pickedHours || undefined,
            days: pickedDays || undefined,
            tab: defaultTab,
            returnTo: 'EditDeliveryTime',
          },
        })
      "
    >
      <span :class="$style.selectLabel">Среднее время доставки</span>
      <span :class="$style.selectValue">
        {{ selectedText || "Не выбрано" }}
        <svg width="24" height="24" viewBox="0 0 24 24" :class="$style.chev">
          <path
            d="M7 10l5 5 5-5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "EditDeliveryTime",
  data() {
    return {
      pickedHours: null,
      pickedDays: null,
      isSaving: false,
      mbHandler: null,
    }
  },
  computed: {
    selectedText() {
      if (this.pickedHours && this.pickedDays)
        return `${this.pickedDays} ${this.plural(
          this.pickedDays,
          "день",
          "дня",
          "дней"
        )} • ${this.pickedHours} ${this.plural(
          this.pickedHours,
          "час",
          "часа",
          "часов"
        )}`
      if (this.pickedDays)
        return `${this.pickedDays} ${this.plural(
          this.pickedDays,
          "день",
          "дня",
          "дней"
        )}`
      if (this.pickedHours)
        return `${this.pickedHours} ${this.plural(
          this.pickedHours,
          "час",
          "часа",
          "часов"
        )}`
      return ""
    },
    defaultTab() {
      if (!this.pickedHours && this.pickedDays) return "days"
      if (this.pickedHours && !this.pickedDays) return "hours"
      return "hours"
    },
    canSave() {
      return Boolean(this.pickedHours || this.pickedDays)
    },
    savePayload() {
      if (this.pickedDays) {
        return {
          delivery_time: Number(this.pickedDays),
          delivery_type: "days",
        }
      }
      if (this.pickedHours) {
        return {
          delivery_time: Number(this.pickedHours),
          delivery_type: "hours",
        }
      }
      return null
    },
  },
  methods: {
    plural(n, one, few, many) {
      const n10 = n % 10,
        n100 = n % 100
      if (n10 === 1 && n100 !== 11) return one
      if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few
      return many
    },
    syncFromRoute() {
      const { hours, days } = this.$route.query || {}
      this.pickedHours = hours ? Number(hours) : null
      this.pickedDays = days ? Number(days) : null
    },
    updateMainButton() {
      const tg = window.Telegram?.WebApp
      const mb = tg?.MainButton
      if (!mb) return

      mb.setText("Сохранить")

      if (this.isSaving) {
        if (mb.showProgress) mb.showProgress(true)
        if (mb.disable) mb.disable()
        return
      } else if (mb.hideProgress) {
        mb.hideProgress()
      }

      if (this.canSave) {
        mb.textColor = "#ffffff"
        mb.color = "#eb5a0a"
        mb.enable()
      } else {
        mb.textColor = "#B9B9BB"
        mb.color = "#E8E8EA"
        mb.enable()
      }
      mb.show()
    },
    async save() {
      if (!this.canSave || !this.savePayload) return
      if (this.isSaving) return

      this.isSaving = true
      this.updateMainButton()
      try {
        await this.$store.dispatch("userUpdate", this.savePayload)
        await this.$store.dispatch("userMe")
        const mb = window.Telegram?.WebApp?.MainButton
        if (mb?.hideProgress) mb.hideProgress()
        if (mb?.hide) mb.hide()
        this.$router.push({ name: "account" })
      } finally {
        this.isSaving = false
        this.updateMainButton()
      }
    },
  },
  mounted() {
    this.syncFromRoute()
    const mb = window.Telegram?.WebApp?.MainButton
    if (mb) {
      this.mbHandler = this.save
      mb.onClick(this.mbHandler)
      this.updateMainButton()
    }
  },
  watch: {
    pickedHours() {
      this.updateMainButton()
    },
    pickedDays() {
      this.updateMainButton()
    },
    $route() {
      this.syncFromRoute()
    },
  },
  beforeUnmount() {
    const mb = window.Telegram?.WebApp?.MainButton
    if (mb && this.mbHandler) mb.offClick(this.mbHandler)
    if (mb?.hideProgress) mb.hideProgress()
    if (mb?.hide) mb.hide()
  },
}
</script>

<style lang="scss" module>
.wrapper {
  --accent: #eb5a0a;
  --text: #161616;
  --muted: #6b6b6f;
  --card: #f6f6f7;
  --border: #ececee;
  padding: 1.875rem 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 800;
  margin: 0.5rem 0;
  color: var(--text);
}

.subtitle {
  width: 100%;
  text-align: center;
  color: var(--muted);
  font-size: 1rem;
  line-height: 1.5;
}

.selectField {
  margin-top: 2.5rem;
  width: 100%;
  background: #f6f6f7;
  border: 1px solid #ececee;
  border-radius: 0.625rem;
  padding: 0.625rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selectLabel {
  font-weight: 400;
  color: var(--text);
  font-size: 1rem;
}

.selectValue {
  margin-left: auto;
  color: #9a9aa0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 1rem;
}

.chev {
  opacity: 0.7;
}
</style>
